import Asset from "../models/household/Asset";
import axios from "axios";

export default {
    namespaced: true,

    getters: {
        assets() {
            return Asset.all();
        },
        householdAssets() {
            return (householdId) => {
                return Asset
                    .query()
                    .with('beneficiaryAssignments.assigned')
                    .where('household_id', householdId)
                    .get();
            }
        },
        getHouseholdAssetsWithBeneficiaries() {
            return (householdId) => {
                return Asset
                    .query()
                    .with('beneficiaryAssignments.assigned')
                    .where('household_id', householdId)
                    .whereHas('beneficiaryAssignments', () => {})
                    .get();
            }
        }
    },

    actions: {
        loadAssets({commit}, {householdId}) {
            return axios
                .get(`api/households/${householdId}/assets`)
                .then((response) => {
                    commit('ASSET_LOADED', response.data.data.assets);
                    return response;
                });
        },
        createAsset({commit}, {asset, householdId}) {
            return axios
                .post(`api/assets`, {...asset, household_id: householdId})
                .then((response) => {
                    commit('ASSET_CREATED', response.data.data.asset);
                    return response;
                });
        },
        updateAsset({commit}, {asset}) {
            return axios
                .put(`api/asset/${asset.id}`, asset)
                .then((response) => {
                    commit('ASSET_UPDATED', asset);
                    return response;
                });
        },
        deleteAsset({commit}, {id}) {
            return axios
                .delete(`api/asset/${id}`)
                .then((response) => {
                    commit('ASSET_DELETED', id);
                    return response;
                });
        }
    },

    mutations: {
        ['ASSET_LOADED'](state, data) {
            if (data) {
                Asset.create({data});
            }
        },
        ['ASSET_CREATED'](state, data) {
            Asset.insert({data});
        },
        ['ASSET_UPDATED'](state, data) {
            Asset.insert({data});
        },
        ['ASSET_DELETED'](state, id) {
            Asset.delete(id);
        }
    }
}
